import { Component, OnInit } from '@angular/core';
import { UserService } from '@service/user/user.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '@modal/confirm-dialog/confirm-dialog.component';
import { FormGroup } from '@angular/forms';
import { User } from '@model/user/user';
import { ToastService } from '@service/toast/toast.service';
import { messages } from '@configuration/messages';
import { ForgotPasswordDialogComponent } from '@modal/forgot-password-dialog/forgot-password-dialog.component';
import { ScrollService } from '@service/scroll.service';
import { ProfileStateComponent } from '@component/profile/profile-state.component';
import { MobileService } from '@service/mobile.service';
import { StateService } from '@service/state.service';
import { SliderImagesService } from '@service/slider-images.service';

@Component({
  selector: 'app-profile-settings',
  templateUrl: './profile-settings.component.html',
  styleUrls: ['./profile-settings.component.scss'],
})
export class ProfileSettingsComponent extends ProfileStateComponent implements OnInit {
  public loading = false;

  public form: FormGroup = null;

  public user: User = null;

  public messages = messages;

  public hasSliderImages: boolean = false;

  constructor(
    private userService: UserService,
    private MatDialog: MatDialog,
    private toastService: ToastService,
    protected scrollService: ScrollService,
    public MobileService: MobileService,
    private StateService: StateService,
    public sliderImagesService: SliderImagesService,
  ) {
    super(scrollService);

    this.userService.userObservable.subscribe((user: User) => {
      this.user = user;
    });
  }

  ngOnInit() {
    super.ngOnInit();

    this.sliderImagesService.hasSliderImages$.subscribe((hasImages: boolean) => {
      this.hasSliderImages = hasImages;
    });

    this.sliderImagesService.checkHasSliderImages('profile');
  }

  public deleteCompanyProfile() {
    const dialogRef = this.MatDialog.open(ConfirmDialogComponent, {
      data: {
        text: 'Sind sie sicher, dass sie ihr Unternehmensprofil löschen wollen?',
        buttons: [
          {
            text: 'Abbrechen',
            value: 'abort',
          },
          {
            text: 'Ja ich bin sicher',
            value: 'keep',
          },
        ],
      },
      disableClose: true,
      panelClass: ConfirmDialogComponent.cssClass,
    });
    dialogRef.afterClosed().subscribe((decision) => {
      if (decision == 'keep') {
        this.loading = true;
        this.userService
          .deleteCompanyProfile()
          .then(() => {
            this.StateService.reload();
            this.userService.refreshUser();
          })
          .catch(() => {
            this.toastService.showError(messages.undefinederror);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    });
  }

  public deleteProfile(): void {
    const dialogConfig = {
      text: 'Sind sie sicher, dass sie ihr Profil unwiderruflich löschen wollen?',
      buttons: [
        {
          text: 'Abbrechen',
          value: 'abort',
        },
        {
          text: 'Ja ich bin sicher',
          value: 'delete',
        },
      ],
    };
    const dialogRef = this.MatDialog.open(ConfirmDialogComponent, {
      data: dialogConfig,
      disableClose: true,
      panelClass: ConfirmDialogComponent.cssClass,
    });
    dialogRef.afterClosed().subscribe((decision) => {
      if (decision == 'delete') {
        this.loading = true;
        this.userService
          .deleteProfile()
          .catch(() => {
            this.toastService.showError(messages.undefinederror);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    });
  }

  public changePassword() {
    this.MatDialog.open(ForgotPasswordDialogComponent, {
      panelClass: 'black-centered-dialog',
    });
  }

  public matToggle(attributename) {
    if (this.user[attributename]) this.user[attributename] = false;
    else this.user[attributename] = true;

    this.loading = true;
    this.userService.updateUser(this.user).finally(() => {
      this.loading = false;
    });
  }
}
